import type { MessageCatalog } from "./en.js";

export const jaMessages = {
  "common.none": "なし",
  "common.missing": "未設定",
  "common.ready": "準備完了",
  "common.unknown": "不明",
  "common.untitled": "（無題）",
  "common.yes": "はい",
  "common.no": "いいえ",
  "command.exit.description": "現在のセッションを終了",
  "command.help.description": "利用可能なコマンドを表示",
  "command.status.description": "現在のプロジェクト状態を表示",
  "command.export.description": "現在の会話を Markdown にエクスポート",
  "command.help.header": "利用可能なコマンド：",
  "command.help.footer": "その他の入力は Kitty に直接送信されます。",
  "tui.idle": "待機中",
  "tui.running": "実行中",
  "tui.thinkingElapsed": "思考中 {elapsed}",
  "tui.background": "バックグラウンド",
  "tui.failed": "失敗",
  "tui.waiting": "待機中",
  "tui.backgroundRunning": "バックグラウンド実行中",
  "tui.model": "モデル",
  "tui.context": "コンテキスト",
  "tui.commands": "コマンド",
  "tui.commandPalette": "パレット",
  "tui.inputPlaceholder": "メッセージを入力",
  "tui.commandQuery": "コマンド",
  "tui.commandQueryPlaceholder": "名前または説明を入力",
  "tui.commandNoMatches": "一致するコマンドはありません",
  "tui.history": "履歴",
  "tui.historyPlaceholder": "キーワードを入力",
  "tui.historyNoMatches": "一致する入力はありません",
  "tui.scrollHelp": "↑↓ スクロール  ·  Esc 閉じる",
  "tui.newContent": "新しい内容があります · End で最下部へ",
  "tui.newContentRows": "新しい行が {count} 行あります · End で最下部へ",
  "tui.copySuccess": "選択した内容をコピーしました。",
  "tui.copyUnavailable": "コピーに失敗しました：この端末ではクリップボードを利用できません。",
  "tui.copyFailed": "コピーに失敗しました：{error}",
  "tui.draftBusy": "SQLite が使用中のため、下書きをまだ送信できません。もう一度お試しください。",
  "tui.externalEditorFailed": "外部エディターに失敗しました：{error}",
  "tui.authorTip": "思いきり探求し、楽しもう！",
  "tui.tool.created": "作成",
  "tui.tool.updated": "更新",
  "tui.tool.read": "読み取り",
  "tui.tool.ran": "実行",
  "tui.tool.updatedPlan": "計画を更新",
  "tui.newSession": "新しいセッション",
  "tui.sessionControls": "↑↓ 選択  ·  Enter 開く  ·  Esc 終了",
  "tui.unnamedSession": "無題のセッション {id}",
  "tui.time.now": "たった今",
  "tui.time.minutes": "{count} 分前",
  "tui.time.hours": "{count} 時間前",
  "tui.time.days": "{count} 日前",
  "tui.time.weeks": "{count} 週間前",
  "tui.time.months": "{count} か月前",
  "tui.time.years": "{count} 年前",
  "tui.help.discovery": "検索",
  "tui.help.input": "入力",
  "tui.help.navigation": "ナビゲーション",
  "tui.help.commandCompletion": "コマンド補完",
  "tui.help.commandPalette": "コマンドパレット",
  "tui.help.historySearch": "入力履歴を検索",
  "tui.help.shortcuts": "キーボードヘルプ",
  "tui.help.submit": "送信",
  "tui.help.newline": "改行",
  "tui.help.lineBounds": "行頭/行末",
  "tui.help.killYank": "行末/行頭/前の単語を切り取り、貼り付け",
  "tui.help.externalEditor": "外部エディター",
  "tui.help.historyNavigation": "複数行入力または履歴内を移動",
  "tui.help.wordMovement": "単語単位で移動",
  "tui.help.menuConfirm": "メニューを補完/確定",
  "tui.help.closeOverlay": "最前面のパネルを閉じる",
  "tui.help.interrupt": "現在の実行を中断",
  "tui.help.redraw": "端末を再描画",
  "interaction.steerAccepted": "現在の会話を誘導しました。",
  "interaction.interrupted": "現在のターンを中断しました。続けて入力できます。",
  "interaction.interrupting": "中断処理中です。",
  "interaction.exitHint": "このセッションは自動終了しません。quit または q を入力してください。",
  "interaction.sessionSaved": "セッションを保存しました。",
  "interaction.turnInterrupted": "ターンを中断しました。会話を続けられます。",
  "interaction.requestFailed": "リクエストに失敗しました。",
  "interaction.sessionAlive": "リクエストに失敗しましたが、セッションは継続できます。",
  "interaction.inputRejected": "入力を受け付けられませんでした：{error}",
  "interaction.recoveredTurns": "中断された {count} 件のターン状態を復元しました。復元可能な作業は永続セッションとツール事実から継続されます。",
  "interaction.inspectProcessesFailed": "実行中のバックグラウンドプロセスを確認できませんでした：{error}",
  "interaction.runningProcesses": "実行中のプロセスがあります。今終了するとすべて停止します。",
  "interaction.killProcessesPrompt": "実行中の全プロセスを停止して終了しますか？[y/N] ",
  "interaction.exitCancelled": "終了をキャンセルしました。バックグラウンドプロセスは継続します。",
  "interaction.stopProcessesPartial": "一部のバックグラウンドプロセスを停止できませんでした。実行中：{pids}。終了をキャンセルしました。",
  "interaction.stoppedProcesses": "バックグラウンドプロセスを {count} 件停止しました。",
  "interaction.stopProcessesFailed": "バックグラウンドプロセスの停止に失敗しました：{error}",
  "interaction.forcedStopPartial": "一部の実行中プロセスを停止できませんでした：{pids}。",
  "interaction.forcedStopped": "実行中プロセスを {count} 件停止しました。",
  "interaction.forcedStopFailed": "実行中プロセスの停止に失敗しました：{error}",
  "local.noMessages": "現在のセッションにはまだメッセージがありません。",
  "local.conversationExported": "現在の会話を書き出しました: {path}",
  "scene.headline.blockedOne": "対応が必要なバックグラウンドタスクが 1 件あります。",
  "scene.headline.blockedMany": "対応が必要なバックグラウンドタスクが {count} 件あります。",
  "scene.headline.watchOne": "出力待ちのバックグラウンドタスクが 1 件実行中です。",
  "scene.headline.watchMany": "出力待ちのバックグラウンドタスクが {count} 件実行中です。",
  "scene.headline.activeOne": "バックグラウンドタスクが 1 件実行中です。",
  "scene.headline.activeMany": "バックグラウンドタスクが {count} 件実行中です。",
  "scene.headline.noSession": "まだセッションは開始されていません。",
  "scene.headline.ready": "最新のセッションは準備完了です。",
  "scene.noFocus": "現在のフォーカスはまだありません。",
  "scene.next.wait": "実行中のタスクを待つか、`kitty status` / `kitty background` で確認してください。",
  "scene.next.start": "`kitty` でセッションを開始してください。",
  "scene.next.continue": "最新のセッションから続行してください。",
  "scene.noBlockers": "表示されているブロッカーはありません。",
  "scene.contextUnmeasured": "コンテキストはまだ計測されていません",
  "scene.providerUsageUnavailable": "provider の usage は利用できません",
  "scene.noModelRequest": "モデルリクエストの記録はありません",
  "scene.noToolProjection": "ツール出力はまだ投影を必要としていません",
  "scene.recoveryOne": "復旧対応が必要なバックグラウンドタスクが 1 件あります。",
  "scene.recoveryMany": "復旧対応が必要なバックグラウンドタスクが {count} 件あります。",
  "scene.wakeOne": "ウェイクシグナルが 1 件記録されています。",
  "scene.wakeMany": "ウェイクシグナルが {count} 件記録されています。",
  "scene.recoveryClear": "復旧状態は正常です。",
  "scene.noSkills": "このプロジェクトでは実行時 skill が見つかりません。",
  "scene.skillIssues": "これらの skill を利用する前に問題を確認してください。",
  "scene.skillsReady": "skills は準備完了です。必要な場合のみ完全な内容を読み込んでください。",
  "scene.noBackground": "実行中のバックグラウンド作業はありません。",
  "scene.backgroundRunning": "バックグラウンド作業を実行中です。待機するか最新出力を確認してください。",
  "scene.executionState": "実行状態：{status}。",
  "scene.executionTask": "{kind} タスク",
  "scene.taskActive": "タスクは実行中です。",
  "scene.cost.context": "コンテキスト {percent}%{compressed}",
  "scene.cost.compressed": "、圧縮済み",
  "scene.cost.stable": "安定プレフィックス {ratio}",
  "scene.cost.totalTokens": "{count} tokens",
  "scene.cost.cacheUnknown": "キャッシュ不明",
  "scene.cost.cached": "{count} キャッシュ済み",
  "scene.cost.cacheHit": "ヒット率 {percent}%",
  "scene.tool.recent": "最近 {count} 件",
  "scene.tool.saved": "推定 {count} tokens 節約",
  "scene.tool.recoverable": "復元可能 {count} 件",
  "scene.tool.degraded": "縮退 {count} 件",
  "scene.execution.backgroundBlocked": "`kitty background read {id}` で出力を確認するか、`kitty background stop {id}` で停止してください。",
  "scene.execution.backgroundWatch": "最初の出力を待つか、`kitty background read {id}` で確認してください。",
  "scene.execution.backgroundActive": "`kitty background read {id}` で確認し、今すぐ結果が必要なら `kitty background wait {id}` を使用してください。",
  "scene.execution.inspectBeforeContinue": "続行前に {kind} {id} を確認してください。",
  "scene.execution.watch": "{kind} {id} の出力または期限を監視してください。",
  "scene.kind.background": "バックグラウンド",
  "status.project": "プロジェクト",
  "status.state": "状態ディレクトリ",
  "status.currentScene": "現在の状況",
  "status.configuration": "現在の設定",
  "status.thinking": "思考モード",
  "status.reasoningEffort": "推論強度",
  "status.extensions": "有効な拡張",
  "status.recentEvents": "最近のイベント",
  "status.now": "現在",
  "status.focus": "フォーカス",
  "status.next": "次の操作",
  "status.blocked": "ブロック",
  "status.background": "バックグラウンド",
  "status.skills": "Skills",
  "status.cost": "コスト",
  "status.toolOutput": "ツール出力",
  "status.recovery": "復旧",
  "status.runtimeFacts": "実行事実",
  "status.session": "セッション",
  "status.sessions": "セッション",
  "status.contextBudget": "コンテキスト予算",
  "status.workset": "ワークセット",
  "status.modelCache": "モデルキャッシュ",
  "status.projectOrientation": "プロジェクト把握",
  "status.executions": "実行",
  "status.wakeSignals": "ウェイクシグナル",
  "status.taskFacts": "タスク事実",
  "status.latestSession": "最新セッション",
  "status.projectFacts": "プロジェクト事実",
  "status.hotspots": "コンテキスト予算のホットスポット",
  "status.sources": "コンテキスト予算のソース",
  "status.cacheLayout": "キャッシュ構成",
  "status.modelRequests": "最近のモデルリクエスト",
  "status.toolOutputs": "最近のツール出力",
  "status.recentExecutions": "最近の実行",
  "status.skillsAttention": "注意が必要な Skills",
  "status.files": "{count} ファイル",
  "status.readyCount": "{ready}/{total} 準備完了",
  "status.activeTotal": "{active} 実行中 / {total} 合計",
  "status.messageCount": "{count} メッセージ",
  "status.compressed": "圧縮={mode}",
  "status.notCompressed": "圧縮=いいえ",
  "status.usageUnavailable": "usage を利用できません",
  "status.usageProviderUnavailable": "provider から usage を取得できません",
  "common.ok": "正常",
  "common.present": "設定済み",
  "common.unresolved": "未解決",
  "common.custom": "カスタム",
  "common.changed": "変更あり",
  "common.clean": "変更なし",
  "common.unavailable": "利用不可",
  "common.notReady": "準備未完了",
  "common.failed": "失敗",
  "common.tracked": "追跡済み",
  "common.interrupted": "中断済み",
  "cli.program.description": "Kitty - 永続的に実行できるエージェント。",
  "cli.version.description": "現在の Kitty バージョンを表示します。",
  "cli.option.model": "設定済みモデルを上書きします",
  "cli.option.cwd": "この実行の作業ディレクトリ",
  "cli.option.json": "構造化 JSON を出力します。",
  "cli.option.timeoutMs": "待機タイムアウト（ミリ秒）。",
  "cli.option.readMode": "読み取りモード: summary、tail、full。",
  "cli.option.tail": "tail モードで読む出力行数。",
  "cli.argument.promptOptional": "任意の単発タスク。省略すると対話モードを開きます。",
  "cli.argument.promptRequired": "送信するタスク",
  "cli.argument.sessionIdOptional": "セッション ID。省略時は最新セッション。",
  "cli.argument.backgroundAction": "任意の操作: list、read、wait、stop",
  "cli.argument.backgroundId": "read、wait、stop で使うバックグラウンド実行 ID",
  "cli.argument.changeIdOptional": "省略可能な変更 ID",
  "cli.command.background": "バックグラウンド実行を確認、読み取り、待機、停止します。",
  "cli.command.start": "プロジェクトを初期化して Kitty ローカルコンソールを開きます。",
  "cli.command.undo": "最新または指定 ID の変更を取り消します。",
  "cli.command.status": "現在のプロジェクト実行状態を表示します。",
  "cli.command.run": "新しいセッションで単発タスクを実行します。",
  "cli.command.resume": "最新または指定セッションを対話モードで再開します。",
  "cli.command.telegram": "Telegram プライベートチャット操作を提供します。",
  "cli.command.telegramServe": "ロングポーリングで Telegram プライベートチャットサービスを実行します。",
  "cli.command.weixin": "Weixin iLink のプライベートチャットから Kitty を操作します。",
  "cli.command.weixinLogin": "QR コードで Weixin iLink にログインします。",
  "cli.command.weixinServe": "Weixin iLink プライベートチャットサービスを実行します。",
  "cli.command.weixinLogout": "Weixin iLink のログイン状態を消去します。",
  "cli.run.incomplete": "実行は完了しませんでした。",
  "cli.background.idRequired": "background {action} には実行 ID が必要です。",
  "cli.background.unknownAction": "不明な background 操作: {action}。list、read、wait、stop を使用してください。",
  "cli.background.none": "バックグラウンド実行の記録はありません。",
  "cli.sessions.none": "保存済みのセッションがありません。",
  "cli.start.ready": "Kitty ローカルコンソールの準備ができました。",
  "cli.start.browserFailed": "ブラウザーを自動で開けませんでした。上の URL を手動で開いてください。",
  "cli.undo.done": "{id} を取り消しました",
  "cli.tui.requiresTty": "kitty には対話型 TTY が必要です。単発実行には kitty run <prompt> を使用してください。",
  "cli.tui.unavailable": "TUI エントリポイントを利用できません。npm.cmd run build を実行して再試行してください。原因: {error}",
  "cli.sessionPicker.prompt": "セッションを選択してください（番号、0 で新規）: ",
  "cli.sessionPicker.recent": "最近のセッション",
  "cli.sessionPicker.new": "新規セッション",
  "cli.sessionPicker.invalid": "無効な選択です。もう一度入力してください。",
  "cli.sessionPicker.invalidRange": "一覧の番号、または新規作成の 0 を入力してください。",
  "cli.intro.session": "セッション",
  "cli.intro.cwd": "作業ディレクトリ",
  "cli.intro.tools": "ツール",
  "cli.intro.commands": "コマンド",
  "preflight.project": "プロジェクト",
  "preflight.state": "状態ディレクトリ",
  "preflight.file": "ファイル",
  "preflight.envKeys": "環境変数",
  "preflight.activeExpected": "有効 {active} / 期待 {expected}",
  "preflight.missingKeys": "不足キー",
  "preflight.provider": "provider",
  "preflight.model": "モデル",
  "preflight.baseUrl": "ベース URL",
  "preflight.providerPreset": "provider プリセット",
  "preflight.providerProfile": "provider プロファイル",
  "preflight.modelProfile": "モデルプロファイル",
  "preflight.wireApi": "通信 API",
  "preflight.catalog": "カタログ",
  "preflight.apiKey": "API キー",
  "preflight.status": "事前確認",
  "preflight.next": "次",
  "preflight.runInit": "`kitty start` を実行してローカル .kitty ファイルを作成し、コンソールを開く",
  "preflight.fillMissing": "`.kitty/.env` を開いて不足キーを入力する",
  "preflight.setApiKey": "`.kitty/.env` に `KITTY_API_KEY` を設定する",
  "preflight.startKitty": "`kitty` で Kitty を開始する",
  "preflight.reviewEnv": "`.kitty/.env` を確認する",
  "status.totalSkipped": "合計 {total}、スキップ {skipped}",
  "status.blockedCount": "ブロック {count}",
  "status.label.reason": "理由",
  "status.label.messages": "メッセージ",
  "status.label.directories": "ディレクトリ",
  "status.label.scripts": "スクリプト",
  "status.label.tests": "テスト",
  "status.label.git": "git",
  "status.label.read": "読み取り",
  "status.label.changed": "変更",
  "status.label.lastTool": "最後のツール",
  "status.label.change": "変更 ID",
  "status.label.chars": "文字",
  "status.label.lines": "行",
  "status.label.stable": "安定プレフィックス",
  "status.label.stableChars": "安定文字数",
  "status.label.tail": "可変末尾",
  "status.label.tailChars": "末尾文字数",
  "status.label.stableRatio": "安定比率",
  "status.label.stableSources": "安定ソース",
  "status.label.volatileSources": "可変ソース",
  "status.label.provider": "provider",
  "status.label.duration": "所要時間",
  "status.label.usage": "使用量",
  "status.label.kind": "種類",
  "status.label.mode": "モード",
  "status.label.raw": "元 tokens",
  "status.label.projected": "投影 tokens",
  "status.label.saved": "節約 tokens",
  "status.label.savedRatio": "節約率",
  "status.label.recoverable": "復元可能",
  "status.label.degraded": "低下",
  "status.label.fullOutput": "完全な出力",
  "status.label.risk": "リスク",
  "status.label.summary": "要約",
  "status.label.next": "次",
  "status.label.lastOutput": "最後の出力",
  "status.label.actor": "実行者",
  "status.label.expected": "期待出力",
  "status.label.resources": "リソース",
  "status.label.dependencies": "依存関係",
  "status.label.host": "ホスト",
  "status.label.message": "メッセージ",
  "status.label.error": "エラー",
  "status.label.state": "状態",
  "status.label.issues": "問題",
  "status.label.cached": "キャッシュ済み",
  "status.label.cacheMiss": "キャッシュミス",
  "status.label.cacheHit": "ヒット率",
  "status.label.input": "入力 tokens",
  "status.label.output": "出力 tokens",
  "status.label.reasoning": "推論 tokens",
  "status.label.cacheRead": "キャッシュ読み取り",
  "status.label.cacheWrite": "キャッシュ書き込み",
  "runtime.channel.agent": "Kitty",
  "runtime.channel.system": "システム",
  "runtime.reasoning": "思考",
  "runtime.tool": "ツール",
  "runtime.result": "結果",
  "runtime.preview": "プレビュー",
  "runtime.content": "内容",
  "runtime.toolFailed": "ツール失敗: {name}",
  "runtime.thinking": "思考中",
  "telegram.help.help": "/help            Telegram の使用方法を表示",
  "telegram.help.stop": "/stop            ボットサービスを停止せず現在の Telegram タスクを停止",
  "telegram.help.status": "/status          現在の実行状態を表示",
  "telegram.help.files": "ファイルの使い方:",
  "telegram.help.sendFile": "- プライベートチャットに直接ファイルを送信します。Kitty がダウンロードして現在のセッションに添付します。",
  "telegram.help.analyzeFile": "- 送信したファイルの分析や、指定ファイルの返信を Kitty に依頼できます。",
  "telegram.help.stopTask": "- 現在のタスクを停止するには /stop を使用します。",
  "telegram.help.note": "端末専用コマンドは Telegram では使用できません。",
  "telegram.blockedLocal": "このコマンドは Telegram では利用できません。/help で利用可能なコマンドを確認してください。",
  "telegram.prefix.warning": "警告",
  "telegram.prefix.error": "エラー",
  "telegram.prefix.interrupt": "中断",
  "telegram.stopConfirmed": "現在の Telegram タスクを停止しています。ボットはオンラインのまま次のリクエストを待ちます。",
  "telegram.noTask": "現在実行中の Telegram タスクはありません。",
  "remote.command.stop.description": "現在のタスクを停止し、サービスをオンラインのまま維持",
  "remote.command.new.description": "以前の履歴を保持して新しいセッションを開始",
  "remote.stopConfirmed": "現在のタスクを停止しています。サービスは次のリクエストのためオンラインのままです。",
  "remote.noTask": "現在実行中のタスクはありません。",
  "remote.newConfirmed": "新しいセッションを開始しました。以前のセッションは保存されています。",
  "remote.noSession": "このチャットにはまだセッションがありません。",
  "remote.blockedCommand": "このコマンドはここでは利用できません。/help で現在のコマンドを確認してください。",
  "telegram.tokenMissing": "Telegram token がありません。KITTY_TELEGRAM_TOKEN または config.telegram.token を設定してください。",
  "telegram.whitelistEmpty": "Telegram ホワイトリストが空です。KITTY_TELEGRAM_ALLOWED_USER_IDS または config.telegram.allowedUserIds を設定してください。",
  "weixin.notLoggedIn": "Weixin にログインしていません。先に kitty weixin login を実行してください。",
  "weixin.whitelistEmpty": "Weixin ホワイトリストが空です。KITTY_WEIXIN_ALLOWED_USER_IDS を設定してください。",
  "weixin.qrCode": "[weixin] Weixin で開くかスキャンしてください: {value}",
  "weixin.scanned": "[weixin] QR コードをスキャンしました。確認を待っています。",
  "weixin.loginSucceeded": "[weixin] ログイン成功 user={userId}",
  "weixin.loggedOut": "[weixin] ログアウトしました。",
  "remote.service.online": "プライベートチャット遠隔サービスが起動しました",
  "remote.service.state": "状態ディレクトリ",
  "remote.service.allowed": "許可ユーザー数",
  "remote.service.transport": "接続方式",
  "cli.setup.projectNotReady": "プロジェクトはまだ実行できません。",
  "cli.setup.createTemplate": "プロジェクトテンプレートを作成または修復: kitty start",
  "cli.setup.configFile": "設定ファイル: {path}",
  "cli.setup.fillAndStart": "必要な値を入力して Kitty を起動してください。",
  "cli.setup.originalError": "元のエラー: {error}",
  "cli.setup.apiKeyMissing": "provider API キーがありません。",
  "cli.setup.setApiKey": "このファイルに KITTY_API_KEY を設定: {path}",
  "cli.setup.thenRestart": "その後 Kitty を再起動してください。",
  "common.active": "有効",
  "common.undone": "取り消し済み",
  "status.label.pid": "プロセス ID",
  "status.label.health": "状態",
  "status.label.deadline": "期限",
  "status.label.files": "ファイル",
  "interaction.queuedRestart": "受け付けた入力は永続化されており、再起動後に続行します。",
  "interaction.detachedRecovery": "現在の作業は永続化されており、このセッションを再度開くと続行します。",
  "web.pageTitle": "Kitty Agent",
  "web.common.back": "ワークスペースに戻る",
  "web.common.save": "設定を保存",
  "web.common.sendTest": "接続をテスト",
  "web.common.testingConnection": "接続、認証情報、モデル一覧を確認しています。しばらくお待ちください…",
  "web.common.start": "開始",
  "web.common.stop": "停止",
  "web.common.github": "GitHub で Kitty を開く",
  "web.common.officialSite": "公式サイト",
  "web.common.apiKeyPortal": "API Key を取得",
  "web.common.notConfigured": "未設定",
  "web.common.custom": "カスタム設定",
  "web.common.requestFailed": "リクエスト失敗（{status}）",
  "web.common.connectionSuccess": "接続成功",
  "web.common.serviceState": "サービス状態：{status}",
  "web.common.models": "{count} モデル",
  "web.common.skills": "利用可能な Skill：{count} 件",
  "web.common.eventUpdated": "イベントが更新されました",
  "web.common.eventDisconnected": "ローカルイベント接続が切断されました。ブラウザは自動再接続します。サービス状態には影響しません。",
  "web.status.stopped": "停止中",
  "web.status.starting": "起動中",
  "web.status.running": "実行中",
  "web.status.stopping": "停止処理中",
  "web.status.failed": "起動失敗",
  "web.status.unknown": "不明な状態",
  "web.login.waiting": "スキャン待ち",
  "web.login.scanned": "スキャン済み",
  "web.login.connected": "ログイン済み",
  "web.login.failed": "ログイン失敗",
  "web.workflow.basic": "基本設定",
  "web.workflow.config": "言語モデル設定",
  "web.workflow.media": "画像・動画設定",
  "web.workflow.plugins": "プラグインと Skill の切り替え",
  "web.workflow.other": "その他の設定",
  "web.workflow.weixin": "Weixin リモートコントロール",
  "web.workflow.telegram": "Telegram リモートコントロール",
  "web.workflow.skills": "Skills",
  "web.workflow.web": "Kitty Web コントロール",
  "web.workflow.loadingConfig": "現在の設定を読み込み中...",
  "web.workflow.loadingService": "サービス状態を読み込み中...",
  "web.workflow.loadingSkills": "機能を読み込み中...",
  "web.workflow.basicNote": "言語とプロファイル",
  "web.workflow.configNote": "Provider とモデル",
  "web.workflow.mediaNote": "画像・動画生成",
  "web.workflow.mediaSummary": "独立したマルチモーダル Provider とモデル設定",
  "web.workflow.pluginsNote": "機能スイッチ",
  "web.workflow.otherNote": "詳細パラメータ",
  "web.workflow.otherSummary": "コンテキスト、ファイル、リモートプロトコル",
  "web.workflow.weixinNote": "Weixin リモートコントロール",
  "web.workflow.telegramNote": "Telegram リモートコントロール",
  "web.workflow.skillsNote": "読み取り専用",
  "web.workflow.webNote": "使いやすいコントロール画面",
  "web.workflow.webSummary": "Web チャットと実行コントロール",
  "web.workflow.guide": "モジュールを選んで Kitty の設定や管理を続けます。",
  "web.config.description": "言語モデルの Provider、認証情報、推論動作を設定します。",
  "web.config.currentTitle": "現在の設定",
  "web.config.providerTitle": "Provider の設定",
  "web.config.providerHint": "プリセットは推奨値を入力します。すべての項目は直接編集できます。",
  "web.config.validationTitle": "接続テスト",
  "web.config.validationHint": "最後に保存した設定でモデル情報を読み取ります。コンテンツを生成せず、モデル Token を消費しません。",
  "web.config.settingsTitle": "モデル動作",
  "web.config.settingsHint": "思考モード、推論強度、出力上限、思考表示は保存後に反映されます。",
  "web.config.extensionsTitle": "Extensions",
  "web.config.runtimeTitle": "実行パラメーター",
  "web.config.preset": "Provider プリセット",
  "web.config.provider": "Provider",
  "web.config.model": "モデル",
  "web.config.baseUrl": "Base URL",
  "web.config.apiKey": "API Key",
  "web.config.apiKeyHint": "現在の Provider のキーです。Provider を切り替えた後、その Provider の API Key を入力してください。",
  "web.config.currentLoaded": "現在値を読み込み済み",
  "web.config.saved": "Kitty の設定を保存しました。",
  "web.config.probeSuccess": "接続成功 · {probe} · {models} · {baseUrl}",
  "web.media.description": "言語モデルとは独立して画像・動画生成を設定します。",
  "web.media.currentTitle": "現在のメディア設定",
  "web.media.providerTitle": "画像・動画 Provider",
  "web.media.providerHint": "画像と動画はメディア認証情報を共有し、言語モデルとは独立します。",
  "web.media.preset": "メディアプリセット",
  "web.media.provider": "Provider",
  "web.media.imageModel": "画像モデル",
  "web.media.videoModel": "動画モデル",
  "web.media.baseUrl": "Base URL",
  "web.media.apiKey": "メディア API Key",
  "web.media.apiKeyHint": "現在のキーを表示します。空欄で保存すると既存値を保持します。",
  "web.media.timeout": "リクエストタイムアウト（ms）",
  "web.media.pollInterval": "動画ポーリング間隔（ms）",
  "web.media.saved": "画像・動画設定を保存しました。",
  "web.media.validationTitle": "メディア接続テスト",
  "web.media.validationHint": "画像や動画を生成せず、モデルエンドポイントだけを確認します。",
  "web.media.studioTitle": "メディアを生成",
  "web.media.studioHint": "設定済みのメディア Provider で画像または動画を直接生成します。",
  "web.media.imageTab": "画像",
  "web.media.videoTab": "動画",
  "web.media.prompt": "プロンプト",
  "web.media.size": "画像サイズ",
  "web.media.ratio": "画像比率",
  "web.media.videoSize": "動画フレーム",
  "web.media.duration": "長さ",
  "web.media.negativePrompt": "ネガティブプロンプト",
  "web.media.generateImage": "画像を生成",
  "web.media.generateVideo": "動画を作成",
  "web.media.stopPolling": "ポーリングを停止",
  "web.media.download": "ダウンロード",
  "web.media.videoId": "動画 ID",
  "web.media.nextPoll": "次回ポーリング",
  "web.media.generating": "画像を生成中…",
  "web.media.imageCompleted": "画像の準備完了",
  "web.media.videoCreating": "動画タスクを作成中…",
  "web.media.videoQueued": "動画は待機中",
  "web.media.videoWaiting": "次のポーリングを待機中",
  "web.media.videoInProgress": "動画を処理中",
  "web.media.videoCompleted": "動画の準備完了",
  "web.basic.description": "現在の profile registry から表示言語と Agent プロファイルを選択します。",
  "web.basic.saved": "基本設定を保存しました。",
  "web.plugins.description": "Kitty のプラグインを切り替え、このプロジェクトの Skills を閲覧します。",
  "web.plugins.saved": "プラグイン設定を保存しました。",
  "web.other.description": "コンテキスト、ファイル制限、Weixin と Telegram の低頻度プロトコル設定を調整します。",
  "web.other.saved": "その他の設定を保存しました。",
  "web.weixin.description": "Kitty を利用できるユーザーを設定し、QR コードでログインしてローカルサービスを開始します。",
  "web.weixin.allowedTitle": "ユーザー許可リスト",
  "web.weixin.userId": "ユーザー ID",
  "web.weixin.usersPlaceholder": "複数の ID はカンマで区切る",
  "web.weixin.saved": "許可ユーザーを保存しました。",
  "web.weixin.loginTitle": "Weixin にログイン",
  "web.weixin.loginHint": "QR コードと認証情報はこのローカルプロジェクトだけに属します。",
  "web.weixin.generateQr": "QR コードを生成",
  "web.weixin.logout": "ログアウト",
  "web.weixin.startTitle": "サービスを開始",
  "web.weixin.startHint": "開始後、メッセージと Agent の動作が下に表示されます。",
  "web.weixin.streamEmpty": "Weixin サービスのイベントがここに表示されます",
  "web.weixin.waitingLogin": "Weixin の QR ログイン待ち",
  "web.weixin.credentialsCleared": "Weixin の認証情報を削除しました",
  "web.weixin.qrGenerating": "QR コードを生成中...",
  "web.weixin.connected": "Weixin の認証情報が接続されました",
  "web.weixin.qrAlt": "Weixin ログイン用 QR コード",
  "web.telegram.description": "Bot Token と許可ユーザーを保存し、Bot の本人確認後にサービスを開始します。",
  "web.telegram.botTitle": "Bot の設定",
  "web.telegram.token": "Bot Token",
  "web.telegram.tokenHint": "`.kitty/.env` の現在値です。空欄で保存すると既存の Token を保持します。",
  "web.telegram.users": "許可するユーザー ID",
  "web.telegram.usersPlaceholder": "複数の ID はカンマで区切る",
  "web.telegram.saved": "Telegram の設定を保存しました。",
  "web.telegram.verifyTitle": "Bot Token を検証",
  "web.telegram.verifyHint": "Telegram の `getMe` を呼び出し、成功時に Bot のユーザー名を表示します。",
  "web.telegram.startTitle": "サービスを開始",
  "web.telegram.startHint": "開始後、Telegram からメッセージを送ると動作全体が下に表示されます。",
  "web.telegram.streamEmpty": "Telegram サービスのイベントがここに表示されます",
  "web.telegram.probeSuccess": "接続成功 · @{identity}",
  "web.skills.description": "このプロジェクトで検出できる機能を閲覧します。ブラウザは Skill ファイルを変更しません。",
  "web.skills.empty": "このプロジェクトで利用できる Skill はありません",
  "web.skills.source": "Skill ソース",
  "web.stream.inbound": "メッセージ受信",
  "web.stream.status": "サービス",
  "web.stream.reasoning": "思考",
  "web.stream.assistant": "返信中",
  "web.stream.final": "最終返信",
  "web.stream.toolCall": "ツール呼び出し",
  "web.stream.toolProgress": "ツール実行中",
  "web.stream.toolResult": "ツール結果",
  "web.stream.toolError": "ツールエラー",
  "web.stream.error": "エラー",
  "web.shell.connected": "接続済み",
  "web.shell.disconnected": "接続が切断されました",
  "web.shell.thinking": "思考中",
  "web.shell.stopped": "停止しました",
  "web.shell.inputPlaceholder": "メッセージを入力",
  "web.shell.send": "送信",
  "web.shell.stop": "停止",
  "web.shell.empty": "Kitty にタスクを渡します。",
  "web.shell.reasoning": "思考中",
  "web.shell.user": "あなた",
  "web.shell.assistant": "Kitty",
  "web.shell.toolUpdating": "{target} を更新中",
  "web.shell.toolWriting": "ファイルを書き込み中",
  "web.shell.toolReading": "{target} を読み込み中",
  "web.shell.toolReadingGeneric": "ファイルを読み込み中",
  "web.shell.toolRunning": "{command} を実行中",
  "web.shell.toolRunningGeneric": "コマンドを実行中",
  "web.shell.toolCalling": "{name} を呼び出し中",
  "web.shell.toolUpdated": "{target} を更新しました",
  "web.shell.toolCreated": "{target} を作成しました",
  "web.shell.toolRead": "{target} を読み込みました",
  "web.shell.toolDone": "ツールが完了しました",
  "web.shell.toolFailed": "ツールが失敗しました",
  "web.shell.toolPlan": "計画を更新 · {completed}/{total} 完了",
  "web.shell.commandDone": "コマンドが完了しました",
  "web.shell.commandFailed": "コマンドが失敗しました",
  "web.runtime.locale": "表示言語",
  "web.runtime.profile": "Agent プロファイル",
  "web.runtime.thinking": "思考モード",
  "web.runtime.reasoningEffort": "推論強度",
  "web.runtime.maxOutputTokens": "最大出力トークン数",
  "web.runtime.contextWindowMessages": "コンテキストメッセージ数",
  "web.runtime.maxContextChars": "最大コンテキスト文字数",
  "web.runtime.contextSummaryChars": "コンテキスト要約文字数",
  "web.runtime.maxReadBytes": "ファイル読み取り上限（バイト）",
  "web.runtime.projectDocMaxBytes": "プロジェクト文書上限（バイト）",
  "web.runtime.commandStallTimeoutMs": "コマンド無出力タイムアウト（ms）",
  "web.runtime.showReasoning": "思考を表示",
  "web.runtime.telegramApiBaseUrl": "Telegram API ベース URL",
  "web.runtime.telegramProxyUrl": "Telegram プロキシ URL",
  "web.runtime.telegramPollingTimeoutSeconds": "Telegram ポーリングタイムアウト（秒）",
  "web.runtime.telegramPollingLimit": "Telegram ポーリング件数",
  "web.runtime.telegramPollingRetryBackoffMs": "Telegram ポーリング再試行間隔（ms）",
  "web.runtime.telegramMessageChunkChars": "Telegram メッセージ分割文字数",
  "web.runtime.telegramTypingIntervalMs": "Telegram 入力中通知間隔（ms）",
  "web.runtime.telegramDeliveryMaxRetries": "Telegram 送信再試行回数",
  "web.runtime.telegramDeliveryBaseDelayMs": "Telegram 送信基本遅延（ms）",
  "web.runtime.telegramDeliveryMaxDelayMs": "Telegram 送信最大遅延（ms）",
  "web.runtime.weixinBaseUrl": "Weixin iLink ベース URL",
  "web.runtime.weixinCdnBaseUrl": "Weixin CDN ベース URL",
  "web.runtime.weixinPollingTimeoutMs": "Weixin ポーリングタイムアウト（ms）",
  "web.runtime.weixinPollingRetryBackoffMs": "Weixin ポーリング再試行間隔（ms）",
  "web.runtime.weixinMessageChunkBytes": "Weixin メッセージ分割サイズ（バイト）",
  "web.runtime.weixinTypingIntervalMs": "Weixin 入力中通知間隔（ms）",
  "web.runtime.weixinQrTimeoutMs": "Weixin QR タイムアウト（ms）",
  "web.runtime.weixinRouteTag": "Weixin ルートタグ",
  "web.locale.zh-CN": "簡体字中国語",
  "web.locale.en": "英語",
  "web.locale.ja": "日本語",
  "web.locale.ko": "韓国語",
  "web.option.enabled": "有効",
  "web.option.disabled": "無効",
  "web.option.xhigh": "最高",
  "web.option.high": "高",
  "web.option.medium": "中",
  "web.option.low": "低",
  "web.option.minimal": "最小",
  "web.option.true": "はい",
  "web.option.false": "いいえ",
  "web.extension.todo": "セッションのチェックリストと進捗表示。",
  "web.extension.scheduler": "モデルのポーリングを使わない永続リマインダーとローカルコマンド予定。",
  "web.extension.worktree": "Git worktree の検出とライフサイクル管理。",
  "web.extension.network": "HTTP リクエスト、疎通確認、ダウンロード、トレース、OpenAPI 検査。",
  "web.extension.media": "画像を生成し、video_id で動画を作成・照会・保存します。",
  "web.extension.background": "ライフサイクルと出力を永続記録するバックグラウンドコマンド。",
  "web.extension.documents": "DOCX とテキスト PDF の範囲読み取り、および Word 文書の作成。",
  "web.extension.skills": "プロジェクト Skill の検出と明示的な読み込み。",
  "web.event.toolFailed": "{name} の実行に失敗",
  "web.event.toolProgress": "{name} が引数を受信中",
  "web.event.writeDocument": "文書を書き込み",
  "web.event.changeFile": "ファイルを変更",
  "web.event.readDocument": "文書を読み取り",
  "web.event.readFile": "ファイルを読み取り",
  "web.event.fromOffset": "{offset} から",
  "web.event.runCommand": "コマンドを実行",
  "web.event.directory": "ディレクトリ：{path}",
  "web.event.runTool": "ツールを実行 · {name}",
  "web.event.fileCreated": "ファイルを作成しました",
  "web.event.fileUpdated": "ファイルを更新しました",
  "web.event.documentCreated": "文書を作成しました",
  "web.event.documentUpdated": "文書を更新しました",
  "web.event.readComplete": "読み取り完了",
  "web.event.commandFailed": "コマンド実行失敗",
  "web.event.commandComplete": "コマンド実行完了",
  "web.event.planUpdated": "Plan を更新 · {completed}/{total}",
  "web.event.toolComplete": "{name} の実行完了",
  "web.event.missingTarget": "対象が指定されていません",
} satisfies MessageCatalog;
